import { FormulaTree } from "utils/services";

export const filteredObjectByValueTypes = ({ object, valueTypes }) => {
  const newObject = {};

  for (const key in object) {
    if (Object.hasOwnProperty.call(object, key)) {
      const valuesArray = object[key];

      const filteredValue = valuesArray.filter((node) => {
        if (
          node.type === FormulaTree.NODE_TYPES.Variable ||
          node.type === FormulaTree.NODE_TYPES.Value ||
          node.type === FormulaTree.NODE_TYPES.Constants
        ) {
          return valueTypes.includes(node.valueType);
        } else {
          return valueTypes.includes(node.returnValueType);
        }
      });

      newObject[key] = filteredValue;
    }
  }
  return newObject;
};
